import { UserState } from './user.types'

export const state: UserState = {
  user: null,
  userError: null,
  loading: false
}
